var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-avatar',{attrs:{"size":"30","color":_vm.theme.color}},[_c('v-icon',{attrs:{"small":"","color":"white"}},[_vm._v(_vm._s(_vm.theme.icon))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }